import { FilePendingUpload } from "@/types/caseFile"

import api from "@/services/api"

export default class FileService {
	public uploadFiles: FilePendingUpload[] = []
	private currentCaseId: string | null = null

	public filesUpdated: () => void

	public constructor (filesUpdated: () => void) {
		this.filesUpdated = filesUpdated
	}

	public get caseId (): string | null {
		return this.currentCaseId
	}
	public set caseId (value: string | null) {
		if (value !== this.currentCaseId) {
			this.uploadFiles = []
		}

		this.currentCaseId = value
	}

	public clear () {
		this.uploadFiles = []
	}

	public addFiles (files: FilePendingUpload[]) {
		files.forEach(file => {
			this.uploadFiles.push(file)
		})
		if (!this.caseId) {
			return
		}

		files.forEach(file => {
			if (file.uploadRun) {
				return
			}
			file.uploadRun = true
			this.uploadFile(file)
		})
	}

	public deleteFile (fileId: string) {
		api.deleteFile(fileId).then(() => {
			this.filesUpdated()
		})
	}

	public async uploadPendingFiles (caseId: string) {
		this.currentCaseId = caseId
		console.log(this.uploadFiles)
		this.uploadFiles.forEach(file => {
			if (file.uploadRun) {
				return
			}
			file.uploadRun = true
			console.log("Uploading " + file.name)
			this.uploadFile(file)
		})
	}

	private uploadFile (uploadFile: FilePendingUpload) {
		const uploadFormData = new FormData()
		uploadFormData.append("file", uploadFile.fileData)

		uploadFile.uploading = true
		uploadFile.uploadPercentage = 0

		api.uploadFiles(this.caseId!, uploadFile.fieldId, uploadFormData, (e: ProgressEvent) => {
			uploadFile.uploadPercentage = Math.round(e.loaded * 100 / e.total)
		},
		(errorMessage: string) => {
			uploadFile.failed = true
			uploadFile.error = errorMessage
			uploadFile.uploading = false
			uploadFile.success = false

			console.log("Failed.")
		},
		() => {
			if (!uploadFile.failed) {
				uploadFile.uploading = false
				uploadFile.success = true

				this.uploadFiles.remove(uploadFile)

				let errorCount = 0
				for (const file of this.uploadFiles) {
					if (file.failed) errorCount++
				}

				if (this.uploadFiles.length === 0 || this.uploadFiles.length === errorCount) {
					this.filesUpdated()
				}
			}
		})
	}
}
